<template>
    <div id="app-mobile">
        <div class="content">
            <slot />
        </div>

        <div class="footer">
            <div
                class="menu-item row align-center justify-center"
                v-for="(item, index) in arrMenuApp"
                :key="index"
                :class="{
                    disabled: item.disable,
                    active: checkActive(item),
                }"
                :style="`width: ${100 / arrMenuApp.length}vw;`"
                @click="
                    () => {
                        if (!item.disable) {
                            $router.push(item.to);
                        }
                    }
                "
            >
                <div class="border-active"></div>
                <i :class="item.icon"></i>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderVue from "@/components/Header/Header.vue";
export default {
    components: {
        HeaderVue,
    },
    data() {
        return {
            idTab: 1,
            arrMenuApp: [
                {
                    id: 1,
                    icon: "mdi mdi-home",
                    to: "/",
                    disable: false,
                },
                {
                    id: 2,
                    icon: "mdi mdi-alpha-v-circle-outline",
                    to: "/Ban-Ve",
                    disable: false,
                },
                // {
                //     id: 3,
                //     icon: "mdi mdi-alpha-t-circle-outline",
                //     to: "/test",
                //     disable: true,
                // },
                // {
                //     id: 4,
                //     icon: "mdi mdi-alpha-b-circle-outline",
                //     to: "/test3",
                //     disable: true,
                // },
                {
                    id: 5,
                    icon: "mdi mdi-account",
                    to: "/Thong-Tin-Tai-Khoan",
                    disable: false,
                },
            ],
        };
    },
    methods: {
        checkActive(item) {
            if (item.to == this.$router.currentRoute?.value?.path) {
                return true;
            }
            return false;
        },
    },
    mounted() {},
};
</script>

<style scoped>
#app-mobile {
    width: 100vw;
    height: 100vh;
    background: #f8f8f8;
}
.content {
    height: calc(100vh - 36px);
    overflow: auto;
}
.footer {
    border-top: 1px solid #dadce0;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 100vw;
    min-height: 36px;
    background-color: #fff;
}
.menu-item {
    color: rgb(0, 0, 0, 0.7);
}
.menu-item.disabled {
    color: #ccc !important;
}
.menu-item.active {
    color: #03a9f4;
    /* border-top: 2px solid #03a9f4; */
}
.menu-item:not(.disabled):active {
    background: rgb(3, 169, 244, 0.1);
}

.border-active {
    opacity: 0;
    position: absolute;
    top: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #03a9f4;
}
@keyframes border_anim {
    0% {
        width: 0%;
    }
    100% {
        width: 100%;
    }
}

.menu-item.active .border-active {
    opacity: 1;
    animation: border_anim 0.2s linear forwards;
}
</style>
